export const getHealthBenefitsDescriptionTitles = (type: string) => {
  switch (type) {
    case 'medical':
      return <span>
        Want to know about Medicals?
      </span>;
    case 'health-savings':
      return <span>
        Want to know about Health Savings Account (HSA)?
      </span>;
    case 'critical-illness':
      return <span>
        Want to know about Critical Illness?
      </span>;
    case 'hospital-indemnity':
      return <span>
        Want to know about Hospital Indemnity?
      </span>;
    case 'dental':
      return <span>
        Want to know about Dental?
      </span>;
    case 'vision':
      return <span>
        Want to know about Vision?
      </span>;
    default:
      return <span></span>;
  }
};

export const getHealthBenefitsDescription = (type: string, more: boolean) => {
  switch (type) {
    case 'medical':
      return <span>
        Your election may require you to select a Primary Care Physician (PCP). 
        If so, be prepared to provide the PCP name and provider code when making 
        your benefit election.
        <div className="mt-10">
          <span>
            When you enroll in medical coverage, you will automatically receive 
            prescription drug coverage for you and your covered
          </span>
          {more && <span> dependents. Depending on the medical option you select, 
            your prescription coverage may be provided directly by your medical 
            plan carrier, or it may be provided by another carrier. Please refer 
            to your health plan coverage information.
          </span>}
        </div>
      </span>;
    case 'health-savings':
      return <span>
        A Health Savings Account (HSA) can be an easy and smart way to save money 
        to pay for qualified medical expenses for you and your dependents. With 
        its triple-tax advantages, easy access to savings, and future growth 
        potential, it's a unique savings vehicle that provides benefits today and 
        in the future.

        {more && <div className="mt-10">
          <span>An HSA is an individual account used in conjunction with a high-deductible 
            health plan (HDHP). Check out all the resources below to learn more or use 
            one of the handy calculators to determine how much you should contribute.
          </span>
            <div className="mt-10">
              The 2023 maximum annual HSA contribution limits are as follows:
            </div>
          <ul className="ms-5 mb-10">
            <li>
              <span>
                $3,850 if you elect eligible medical coverage for yourself only
              </span>
            </li>
            <li>
              <span>
                $7,750 if you elect eligible medical coverage for yourself plus at least one family member
              </span>
            </li>
            <li>
              <span>
                An additional $1,000 if you will be age 55 or older on December 31
              </span>
            </li>
          </ul>
          <span className="mb-10">
            You must have a current HSA account open with BenefitWallet in order to 
            access your account online. Company contributions, if eligible, cannot be 
            made unless you have an open account.
          </span>
        </div>}
      </span>;
    case 'critical-illness':
      return <span>
        Critical Illness insurance provides a lump-sum, cash benefit if you or a 
        covered family member is diagnosed with a specified critical illness, 
        such as cancer, heart attack or stroke. You may spend the money to pay 
        expenses not covered by a medical plan, such as day care, special 
        transportation to and from treatments or unique treatments. Or you can 
        use the benefits to pay
        {more && <span> deductibles and co-payments under your medical plan. Note that the 
          diagnosis of a covered critical illness must occur after your coverage 
          is effective and while your coverage is not lapsed or canceled. This 
          insurance does not include a limitation due to a pre-existing condition.
          <div className="mt-10">
            Your eligible dependent children may be included in this coverage 
            up to age 26. This insurance is voluntary, meaning you are responsible 
            for paying the premiums. Premiums are paid on a post-tax basis. 
            Enrollment is available when you are first eligible, and at Annual 
            Enrollment.
          </div>
        </span>}
      </span>;
    case 'hospital-indemnity':
      return <span>
        Hospital Indemnity insurance can help you with out-of-pocket medical 
        expenses associated with hospital confinements. This coverage provides 
        cash benefits for hospital and intensive care confinements. Benefits are 
        paid in addition to medical or any other benefits you may receive and 
        are paid directly to you unless assigned to someone else. Note that the 
        hospitalization must occur
        {more && <span> after your coverage is effective and while your coverage 
          is not lapsed or canceled. This coverage does not include a limitation 
          due to a pre-existing condition.
          <div className="mt-10">
            Your eligible dependent children may be included in this coverage up 
            to age 26. This insurance is voluntary, meaning you are responsible 
            for paying the premiums. Premiums are paid on a post-tax basis. 
            Enrollment is available when you are first eligible, and at Annual 
            Enrollment.
          </div>
        </span>}
      </span>;
    case 'dental':
      return <span>
        If you are eligible for and considering electing a dental DMO plan, you 
        must see a dental network provider. When you first elect a dental DMO 
        plan, you will be brought to the Dental Provider Information screen 
        automatically if your election requires you to select a network provider.
        {more && <div className="mt-10">
          If you subsequently move from one dental DMO service area to another, 
          you will need to see a new dental network provider as moving between 
          dental DMO service areas is not a qualified status change and you will 
          not be permitted to change your plan election. Changes in a dental 
          network provider cannot be made on this website and can only be made by 
          calling the dental plan provider directly or accessing the plan 
          provider’s website.
        </div>}
      </span>;
    case 'vision':
      return <span>
        Vision plan coverage is available to help with the cost of eye exams, 
        prescription lenses, frames and contact lenses for you and your covered 
        dependents.
      </span>;
    default:
      return <span></span>;
  }
};
